export default {
    topics: [
        {
            title: ' AddInstance ',
            href: 'sm-serverOptions-AddInstance.html',
            attributes: { 'data-id': 'sm-serverOptions-AddInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-serverOptions-AddInstance-d66e1293',
            topics: [],
        },
        {
            title: ' LoadOptions ',
            href: 'sm-serverOptions-LoadOptions.html',
            attributes: { 'data-id': 'sm-serverOptions-LoadOptions' },
            menu: { hasChildren: false },
            tocID: 'sm-serverOptions-LoadOptions-d66e1301',
            topics: [],
        },
        {
            title: ' SaveOptions ',
            href: 'sm-serverOptions-SaveOptions.html',
            attributes: { 'data-id': 'sm-serverOptions-SaveOptions' },
            menu: { hasChildren: false },
            tocID: 'sm-serverOptions-SaveOptions-d66e1309',
            topics: [],
        },
    ],
};

